import React from "react";

function Header() {
  return (
    <header className="w-full sticky top-0 flex items-center bg-background px-6 lg:px-16 py-2 shadow-md cursor-default">
      <h1 className="text-purple-primary outline-purple-secondary outline-1 text-2xl lg:text-4xl">
        wtf
      </h1>
    </header>
  );
}

export default Header;
